import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../utils/cn';
import { PANEL_PADDING_CLASSES, PANEL_VARIANT_CLASSES, type PanelPadding, type PanelVariant } from './panelStyles';

export type { PanelVariant, PanelPadding };

export interface PanelProps extends HTMLAttributes<HTMLDivElement> {
    variant?: PanelVariant;
    padding?: PanelPadding;
}

export const Panel = forwardRef<HTMLDivElement, PanelProps>(function Panel(
    { variant = 'solid', padding = 'md', className, ...rest },
    ref,
) {
    return (
        <div
            ref={ref}
            className={cn(PANEL_VARIANT_CLASSES[variant], PANEL_PADDING_CLASSES[padding], className)}
            {...rest}
        />
    );
});

export default Panel;
